export const TREATMENTS = ["Reutilización", "Preparación para reutilización", "Reciclaje", "Coprocesamiento", "Compostaje / Digestión anaeróbica", "Valorización energética", "Re-refinado"];

export const GESTOR_GIROS = ["Reciclaje de desperdicios y desechos", "Fabricación de materias primas secundarias", "Valorización de residuos", "Gestión / tratamiento de residuos no peligrosos", "Recolección y transporte de residuos", "Fundición / refinación de metales"];

export const DOC_TYPES = ["Factura electrónica", "Boleta electrónica", "Guía de despacho", "Sin documento tributario (donación)"];

export const STEPS = [
  { id: "adjudicada", label: "Adjudicación", desc: "Cierre de la oferta y aceptación de términos" },
  { id: "retiro_programado", label: "Orden de Retiro", desc: "Fecha, hora, ubicación, volumen, transportista validado y patente" },
  { id: "retirado", label: "Check-in en terreno", desc: "Pesaje final y comprobante digital (QR)" },
  { id: "recibido", label: "Check-out en destino", desc: "Recepción conforme en planta" },
  { id: "cerrada", label: "Cierre y certificado", desc: "Documento tributario y certificado ESG" },
];

export const STEP_INDEX = Object.fromEntries(STEPS.map((s, i) => [s.id, i]));

export const EVENT_LABELS = {
  adjudicacion: "Adjudicación del lote",
  orden_retiro: "Orden de Retiro emitida",
  retiro_validado: "Retiro validado en terreno (QR)",
  recepcion_destino: "Recepción confirmada en destino",
  cierre_documental: "Documento tributario registrado",
  certificado_emitido: "Certificado de Valorización emitido",
};

export const GESTOR_STATUS = {
  vigente: { label: "Gestor declarado · vigente", cls: "bg-[#00f2a1]/15 text-[#007a50] border-[#00f2a1]/40" },
  vencido: { label: "Declaración vencida", cls: "bg-red-50 text-red-700 border-red-200" },
  incompleto: { label: "Declaración incompleta", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  no_declarado: { label: "Sin declaración de gestor", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const cleanRut = (r) => (r || "").replace(/[^0-9kK]/g, "").toUpperCase();

export const validRut = (rut) => {
  const r = cleanRut(rut);
  if (r.length < 8) return false;
  const body = r.slice(0, -1);
  if (!/^\d+$/.test(body)) return false;
  let s = 0;
  let m = 2;
  for (const d of body.split("").reverse()) {
    s += Number(d) * m;
    m = m === 7 ? 2 : m + 1;
  }
  const res = 11 - (s % 11);
  const dv = res === 11 ? "0" : res === 10 ? "K" : String(res);
  return r.slice(-1) === dv;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("es-CL", { dateStyle: "medium", timeStyle: "short" }) : "—");
